
import Vue from 'vue'
import { SearchFacets } from '@/search/types'
import { FACET_QUERY_PREFIX } from '@/search/const'
import { browser } from '@/common/userAgent'


export default Vue.extend({
  name: 'SidebarFacetSearch',
  props: {
    categoryId: {
      type: Number,
      required: true
    },
    facetData: {
      type: Array as () => SearchFacets[],
      required: true
    }
  },
  computed: {
    isIE(): boolean {
      return browser.isIE
    }
  },
  methods:{
    goToSearchPage(key: string, value: string) {
      window.open(
        `/search?category=${this.categoryId}&${FACET_QUERY_PREFIX}${key}=${value}`,
        this.isIE ? '_self' : '_blank',
        this.isIE ? '' : 'noreferrer noopener'
      )
    }
  }
})
